import PersonalInformationApiTempWorker from '@/api/PersonalInformationApiTempWorker';

class PersonalInformationService {

	async getAsync () {
		const { data } = await PersonalInformationApiTempWorker.get();
		return data;
	}

	async updateAsync (...arg: Parameters<typeof PersonalInformationApiTempWorker.update>) {
		const { data } = await PersonalInformationApiTempWorker.update(...arg);
		return data;
	}

}

const personalInformationServiceSingleton = new PersonalInformationService();

export default function usePersonalInformationService () {
	return personalInformationServiceSingleton;
}
